import React from 'react';

type TCardInfo = {
  header: string;
  subhead: string;
  content: string;
  status: string;
  project_id: number;
};

export type TCustomIcon = {
  fill?: string;
  strokeWidth?: number;
  stroke?: string;
  className?: string;
};

type TButton = {
  isDisabled: boolean;
  isOutlined: boolean;
};

type TProtectedRoute = {
  children?: React.ReactNode;
};

type AuthState = {
  token: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null | undefined;
};

type TokenResponse = {
  access_token: string;
  token_type: string;
};

export type TLoginFormValues = {
  userName: string;
  password: string;
};

type TSuggestion = {
  id: string;
  level: number;
  name: string;
};

export type TSuggestions = {
  suggestions: TSuggestion[];
};

export type TCarbonProjectData = {
  type: string;
  geometry: {
    type: string;
    coordinates: [number, number];
  };
  properties: TCarbonProjectDataProperties;
};

export type TCarbonProjectDataProperties = {
  id: number;
  project_id: number;
  name: string;
  project_type: string;
  methodology: string;
  status: string;
  estimated_annual_emission_reduction: number;
  credit_period_start_date: string;
  credit_period_end_date: string;
  registry: string;
  url: string;
  description: string;
  validator_name: string;
  proponent_name: string;
  area: number | null;
  country: string;
  isSaved: boolean;
};

type TTitle = {
  text: string;
};

export enum RecommendationProjectTypeEnum {
  Mangroves = 'Mangroves',
  Forests = 'Forests',
}

export type TRecommendationProjectType =
  | RecommendationProjectTypeEnum.Mangroves
  | RecommendationProjectTypeEnum.Forests;

// new recommendation project type
export type TRecommendedProject = {
  adm2?: string;
  adm_name?: string;
  country: string;
  country_code: string;
  id: number;
  isSaved: boolean;
  total_area?: number;
  type: string;
};

export type TRecommendedProjectData = TRecommendedProject & {
  adm1: string;
  area_in_hector: number;
  latitude: number;
  longitude: number;
  estimated_annual_credit?: number;
};

// TODO: should be removed
export type TRecommendation = {
  hasc_one?: string;
  name: string;
  gid_zero?: string;
  potential_mangrove: number;
  afolu_activities?: string;
  id: number;
  mangrove_degradation: number;
  methedology?: string;
  country: string;
  mangrove_coverage: number;
  status: string;
  gid_one?: string;
  geo_id?: string;
  estimated_annual_emission_reduction?: number | null;
  name_one: string;
  type_id?: number;
  description?: string;
  type_one?: string;
  sub_type_id?: number;
  location?: string | null;
  eng_type_one?: string;
  project_type: string;
  subtype: string;
};

type TRecommendations = {
  mangroves: TRecommendation[];
};

type TRecommendationObject = {
  recommendations: TRecommendations;
};

export type FavoriteProject = {
  id: number;
  project_id?: number;
  name: string;
  project_type: string;
  methodology: string;
  status: string;
  estimated_annual_emission_reduction: number;
  credit_period_start_date?: string;
  credit_period_end_date?: string;
  registry?: string;
  url?: string;
  description: string;
  validator_name: string;
  proponent_name: string;
  area: number | null;
  country: string;
};

type FavoriteProjects = {
  favorites: FavoriteProject[];
};

export type FavoriteProjectsResponse = {
  mangrove_projects: TRecommendation[];
  carbon_projects: TCarbonProjectDataProperties[];
};

export type FavoriteProjectsIds = {
  mangrove_recommendations: number[];
  current_projects: number[];
};

export type DocumentTemplate = {
  name: string;
  metaData: unknown;
  content: string;
};

export type CiidAccessTokenPayload = {
  sub: string;
  role: UserRoles;
  id: number;
  exp: Date;
};

export enum UserRoles {
  GENERAL = 'GENERAL',
  ADMIN = 'ADMIN',
  ADMIN_APPROVER = 'ADMIN_APPROVER',
}

export type UserData = {
  id: number;
  username: string;
  email: string;
  disabled?: boolean | null;
  role?: UserRoles;
  favourites?: {
    carbon_projects: string[];
    mangrove_projects: string[];
  } | null;
  lastLogin: string;
};

export type AuditLog = {
  action: string;
  details: string;
  id: number;
  status: string;
  timestamp: string;
  user_id: number;
  user: {
    email: string;
    id: number;
    role: UserRoles;
    username: string;
  };
};

export type PaginationResponse<T> = {
  data: T[];
  page: number;
  pages: number;
  per_page: number;
  total: number;
};

export type PddDocument = {
  id: number;
  status: string;
  project_id: string;
  pdd_template_id: string;
  created_at: string;
  updated_at: string;
  name: string;
  description: string;
  user_id: number;
};

export type RecommendationPagination = {
  aggregatedFinish: boolean;
  totalItems: number;
  currentPageNumber: number;
  totalAggregated: number;
  totalDistrict: number;
  skippedDistrict: number;
};

type RecommendationsByDistrictsResponse = {
  items: TRecommendedProject[];
  limit: number;
  skip: number;
  total: {
    all: number;
    carbon_projects: number;
    recommendations: number;
    searched: number;
    saved: number;
  };
};
